<div class="row h-100 landing-page-container">
        <div *ngFor='let role of userRoles' (click)='selectTool(role.role_privilege_route)'
                class="col-6 col-sm-4 col-md-3 col-lg-2 text-center my-auto">
                <div class="rectangle">
                        <img class="logo-image-aligner" src={{role.image_path}} />
                        <div class="card-text">{{role.label}}</div>
                </div>
        </div>
</div>
<app-loader-spinner *ngIf="loading" [type]="'landing'"></app-loader-spinner>